import { Image as AntImage, Button, Input, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import defaultImage from "../../assets/images/avatar-1.png";
import Plus from "../../assets/images/plus.svg";
import ConfirmationBox from "../../components/ConfirmationBox";
import DeleteModal from "../../components/DeleteModal";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import AddFrom from "./AddForm";
import { useLocation } from "react-router-dom";

function Index() {
  const heading = lang("User") + " " + lang("management");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { setPageHeading } = useContext(AppStateContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(null); // true | false | null
  const [filters, setFilters] = useState({});

  const sectionName = "Add User";
  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("status");

  const api = {
    list: apiPath.userList,
    addEdit: apiPath.userAddEdit,
    statusChange: apiPath.userStatusChanges,
    delete: apiPath.userDelete,
  };

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const navigate = useNavigate();
  const { showConfirm } = ConfirmationBox();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [actionType, setActionType] = useState("");
  const [constituencyList, setConstituencyList] = useState([]);
  const [selectedConstituency, setSelectedConstituency] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);

  const view = (id) => {
    navigate(`/user/view/${id}`);
  };

  const onDelete = (id) => {
    request({
      url: api.delete + "/" + id,
      method: "PUT",
      onSuccess: (data) => {
        setLoading(false);
        ShowToast("User Deleted Successfully", Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id) => {
    request({
      url: api.statusChange + "/" + id,
      method: "PUT",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "Profile",
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => {
        const imageUrl = image || defaultImage;
        return (
          <AntImage
            src={imageUrl}
            alt="profile"
            width={40}
            height={40}
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              border: "1px solid #eee",
            }}
            preview={{ mask: "Preview" }}
          />
        );
      },
    },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => {
        return name ? name : "-";
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (_, { email }) => {
        return email ? email : "-";
      },
      onCell: () => ({
        className: "email-cell-class",
      }),
    },
    {
      title: "Initial Credits",
      dataIndex: "initial_credit",
      key: "initial_credit",
      render: (_, { initial_credit }) => {
        return initial_credit ? initial_credit : "-";
      },
    },
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "Inactive",
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        let color = is_active ? "green" : "red";
        return (
          <a>
            <Tag
              onClick={(e) =>
                showConfirm({
                  record: _id,
                  path: api.statusChange,
                  onLoading: () => setLoading(true),
                  onSuccess: () => {
                    setRefresh((prev) => !prev);
                    ShowToast(
                      `Status changed to ${
                        !is_active ? "Active" : "Inactive"
                      } successfully`,
                      Severty.SUCCESS
                    );
                  },
                })
              }
              color={color}
              key={is_active}
            >
              {is_active ? "Active" : "Inactive"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: "Added Date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-content-start">
            <Tooltip title={"Edit"} color={"purple"} key={"edit"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <i class="fas fa-edit"></i>
                {/* <span>Edit</span> */}
              </Button>
            </Tooltip>
            <Tooltip title={"View"} color={"purple"}>
              <Button className="tbl-view-btn" onClick={() => view(record._id)}>
                <i class="fas fa-eye"></i>
              </Button>
            </Tooltip>
            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                title="Delete"
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i class="fas fa-trash"></i>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    fetchData({ ...pagination, current: 1 });
  }, [refresh, debouncedSearchText, startDate, endDate, selectedConstituency]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = ({
    page = 1,
    pageSize = 10,
    search = "",
    filters = {},
    startDate = "",
    endDate = "",
    selectedConstituency = "",
  }) => {
    const filterActive = filters.is_active || [];

    setLoading(true);

    // Handle status param from URL
    const statusParam =
      path === "active"
        ? "&status=active"
        : path === "inactive"
        ? "&status=inactive"
        : filterActive.length
        ? `&status=${filterActive.join(",")}`
        : "";

    const url =
      api.list +
      `?page=${page}` +
      `&pageSize=${pageSize}` +
      `&search=${search}` +
      statusParam +
      `&start_date=${startDate}` +
      `&end_date=${endDate}` +
      `&constituency_id=${selectedConstituency || ""}`;

    request({
      url,
      method: "GET",
      onSuccess: ({ data, status }) => {
        setLoading(false);
        if (status) {
          setList(data?.list?.docs || []);
          setPagination({
            current: data?.list?.page,
            total: data?.list?.totalDocs,
            pageSize: data?.list?.limit,
          });
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (paginationInfo, filtersFromTable) => {
    setFilters(filtersFromTable);
    setPagination(paginationInfo);

    fetchData({
      page: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
      filters: filtersFromTable,
      search: searchTerm, // or debouncedSearchText if used
      startDate,
      endDate,
      selectedConstituency,
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };
  return (
    <>
      <SectionWrapper
        cardHeading={lang("User") + " " + lang("list")}
        extra={
          <>
            <div className="w-100 d-flex align-items-baseline text-head_right_cont">
              <div className="pageHeadingSearch d-flex gap-2">
                <Input.Search
                  allowClear
                  className="searchInput"
                  placeholder="Search by Name, Email"
                  onChange={(e) => {
                    const value = e.target.value.trimStart();
                    setSearchTerm(value);

                    fetchData({
                      page: 1,
                      pageSize: pagination.pageSize,
                      filters,
                      search: value,
                      startDate,
                      endDate,
                      selectedConstituency,
                    });

                    setPagination((prev) => ({ ...prev, current: 1 }));
                  }}
                />
              </div>
              <Button
                className="primary_btn btnStyle"
                onClick={(e) => {
                  setVisible(true);
                  setSearchText("");
                }}
              >
                <span className="add-Ic">
                  <img src={Plus} />
                </span>
                {sectionName}
              </Button>
            </div>
          </>
        }
      >
        <div className="table-responsive customPagination">
          <Table
            loading={loading}
            columns={columns}
            dataSource={list}
            pagination={{
              current: pagination.current,
              defaultPageSize: pagination.pageSize,
              responsive: true,
              total: pagination.total,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
            onChange={handleChange}
            className="ant-border-space"
          />
        </div>
      </SectionWrapper>

      {visible && (
        <AddFrom
          section={sectionName}
          api={api}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      {showDelete && (
        <DeleteModal
          title={"Delete User"}
          subtitle={`Are you sure you want to Delete this User?`}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
      {showStatus && (
        <DeleteModal
          title={`${selected?.is_active ? `Block` : `UnBlock`} User`}
          subtitle={`Are you sure you want to ${
            selected?.is_active ? `block` : `unblock`
          } this user?`}
          show={showStatus}
          hide={() => {
            setShowStatus(false);
            setSelected();
          }}
          onOk={() => handleChangeStatus(selected?._id)}
        />
      )}
    </>
  );
}

export default Index;
